export default {
  labels: {
    google_place: 'Posizione Google',
    live: 'Live',
    setting_up: 'Configurazione in corso',
  },
  buttons: {
    confirm: 'Conferma',
    cancel: 'Annulla',
    continue_setup: 'Continua configurazione',
  },
  delete_confirmation: 'Sei sicuro?',
};
